module.exports = __webpack_public_path__ + "static/media/background.e5a5f504.avif";